import {
  Box,
  Grid,
  createTheme,
  ThemeProvider,
  Menu,
  Stack,
  Select,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import { format } from "date-fns";
import Dialog from "@mui/material/Dialog";
import ListItemText from "@mui/material/ListItemText";
import Divider from "@mui/material/Divider";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import MenuItem from "@mui/material/MenuItem";
import MUIDataTable from "mui-datatables";
import MoreHorizTwoToneIcon from "@mui/icons-material/MoreHorizTwoTone";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import EditNoteIcon from "@mui/icons-material/EditNote";
import { useNavigate } from "react-router-dom";
import StatusAlert from "../../StatusAlertList/StatusAlert";
import ReactQuill from "react-quill";
import config from "../../Data/AuthUser";
import { driverRequestsApis } from "../../Data/axios";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function DriverRequest() {
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);
  const [descriptionRemark, setDescriptionRemark] = React.useState("");
  const [openRemark, setOpenRemark] = React.useState(false);
  const [dateDropdownOpen, setDateDropdownOpen] = useState(false);
  const [requestData, setRequestData] = useState([]);
  const [openMenuId, setOpenMenuId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current_page: 1,
    per_page: 5,
    total_records: 0,
    total_pages: 1
  });

  // Filter states
  const [searchValue, setSearchValue] = useState("");
  const [selectedCorporation, setSelectedCorporation] = useState("all");
  const [statusFilter, setStatusFilter] = useState("all");

  // Alert states
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertSeverity, setAlertSeverity] = useState("info");

  const [statusType, setStatusType] = useState("");
  
  const navigate = useNavigate();

  const showAlert = (message, severity) => {
    setAlertMessage(message);
    setAlertSeverity(severity);
    setAlertOpen(true);
  };

  function formatDate(isoString) {
    const date = new Date(isoString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12;
    return `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;
  }

  const handleOpenMenu = (id) => {
    setOpenMenuId(id);
  };

  const handleViewMore = async () => {
    navigate(`/driver_requests/${openMenuId}`, { state: { id: openMenuId } });
  };

  const handleUpdateDetails = () => {
    setOpenRemark(true);
  };

  const handleCloseRemark = () => {
    setOpenRemark(false);
    setStatusType("");
    setDescriptionRemark("");
  };

  const handleFiltersOpen = () => {
    console.log("Filters button clicked");
  };

  // Fetch driver requests data
  const getData = async (page = 1, limit = rowsPerPage, filters = {}) => {
    try {
      setLoading(true);
      
      // Prepare filters object
      const apiFilters = {
        ...(searchValue && { search: searchValue }),
        ...(selectedCorporation !== "all" && { client_id: selectedCorporation }),
        ...(statusFilter !== "all" && { status: statusFilter })
      };

      const response = await driverRequestsApis.getAll(page, limit, apiFilters, 'admin');
      
      if (response.success) {
        setRequestData(response.data.data || []);
        setPagination(response.data.pagination || {
          current_page: page,
          per_page: limit,
          total_records: 0,
          total_pages: 1
        });
      } else {
        showAlert(response.message || "Failed to fetch driver requests", "error");
        setRequestData([]);
      }
    } catch (error) {
      console.error("Error fetching driver requests:", error);
      showAlert("Error fetching driver requests", "error");
      setRequestData([]);
    } finally {
      setLoading(false);
    }
  };

  // Initial data load
  useEffect(() => {
    getData(currentPage, rowsPerPage);
  }, [currentPage, rowsPerPage]);

  // Handle search and filters
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setCurrentPage(1);
      getData(1, rowsPerPage);
    }, 500);

    return () => clearTimeout(timeoutId);
  }, [searchValue, selectedCorporation, statusFilter]);

  const requestStatus = (value) => {
    switch (parseInt(value)) {
      case 0:
        return <span style={{ color: "red", fontSize: "15px" }}>Canceled</span>;
      case 1:
        return <span style={{ color: "orange", fontSize: "15px" }}>New</span>;
      case 2:
        return <span style={{ color: "green", fontSize: "15px" }}>Accepted</span>;
      case 3:
        return <span style={{ color: "blue", fontSize: "15px" }}>In Progress</span>;
      case 4:
        return <span style={{ color: "purple", fontSize: "15px" }}>Partial</span>;
      case 5:
        return <span style={{ color: "darkgreen", fontSize: "15px" }}>Completed</span>;
      default:
        return <span style={{ color: "gray", fontSize: "15px" }}>Unknown</span>;
    }
  };

  const modules = {
    toolbar: [
      [{ header: "1" }, { header: "2" }, { font: [] }],
      [{ size: [] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      ["link"],
      ["clean"],
    ],
  };

  const [anchorEl, setAnchorEl] = React.useState(null);
  const openDropMenu = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const columns = [
    {
      name: "client_id",
      label: "Client",
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "center",
                borderBottom: "1px solid #ddd",
              }}
            >
              Client
            </th>
          );
        },
        customBodyRender: (value, tableMeta) => {
          const rowIndex = tableMeta.rowIndex;
          const fullRecord = requestData[rowIndex];

          if (!fullRecord) {
            return <div>Loading...</div>;
          }

          const imageUrl = fullRecord.app_user?.image && fullRecord.app_user.image !== "non" 
            ? `${config.apiImageUrl}${fullRecord.app_user.image}` 
            : "/default-avatar.png";

          // Use the user_id (RPTPLCLNT format) from app_user for navigation
          const userId = fullRecord.app_user?.user_id;

          return (
            <div
              key={value}
              style={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
              }}
              onClick={() => {
                if (userId) {
                  navigate(`/clients/${userId}`, { state: userId });
                } else {
                  alert("Client user_id not found!");
                }
              }}
            >
              <img
                src={imageUrl}
                alt="client"
                style={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "50%",
                  objectFit: "cover",
                  marginRight: "10px",
                }}

              />
              <div>
                <div style={{ fontWeight: "bold" }}>
                  {fullRecord.app_user?.username || "N/A"}
                </div>
                <div style={{ color: "gray" }}>{userId || ""}</div>
              </div>
            </div>
          );
        },
      },
    },
    {
      name: "no_of_users",
      label: "Total Drivers",
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "center",
                borderBottom: "1px solid #ddd",
              }}
            >
              Total Drivers
            </th>
          );
        },
        customBodyRender: (value) => {
          return (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              {value || 0}
            </div>
          );
        },
      },
    },
    {
      name: "assigned_to",
      label: "Assigned To",
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "center",
                borderBottom: "1px solid #ddd",
              }}
            >
              Assigned To
            </th>
          );
        },
        customBodyRender: (value) => {
          return (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              {value ? (
                <div>
                  <div style={{ fontWeight: "bold" }}>{value.name}</div>
                  <div style={{ color: "gray", fontSize: "12px" }}>{value.role}</div>
                </div>
              ) : (
                "Not Assigned"
              )}
            </div>
          );
        },
      },
    },
    {
      name: "status",
      label: "Status",
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "center",
                borderBottom: "1px solid #ddd",
              }}
            >
              Status
            </th>
          );
        },
        customBodyRender: (value) => {
          return (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              {requestStatus(value)}
            </div>
          );
        },
      },
    },
    {
      name: "created_at",
      label: "Created",
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "center",
                borderBottom: "1px solid #ddd",
              }}
            >
              Created
            </th>
          );
        },
        customBodyRender: (value) => {
          const formattedDate = format(new Date(value), "dd-MM-yyyy HH:mm");
          return (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              {formattedDate}
            </div>
          );
        },
      },
    },
    {
      name: "id",
      label: "Action",
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "right",
                paddingRight: "70px",
                borderBottom: "1px solid #ddd",
              }}
            >
              Action
            </th>
          );
        },
        customBodyRender: (value, tableMeta) => {
          const rowIndex = tableMeta.rowIndex;
          const fullRecord = requestData[rowIndex];
          const isNewStatus = fullRecord?.status === 1;

          return (
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                paddingRight: "20px",
              }}
            >
              <div style={{ paddingRight: "20px" }}>
                <Button
                  id="basic-button"
                  aria-controls={openDropMenu ? "basic-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={openDropMenu ? "true" : undefined}
                  onClick={handleClick}
                >
                  <div onClick={() => handleOpenMenu(value)}>
                    <MoreHorizTwoToneIcon />
                  </div>
                </Button>
                <Menu
                  id="basic-menu"
                  anchorEl={anchorEl}
                  open={openDropMenu}
                  onClose={handleCloseMenu}
                  MenuListProps={{
                    "aria-labelledby": "basic-button",
                  }}
                >
                  <MenuItem onClick={handleCloseMenu}>
                    <div
                      onClick={() => handleViewMore()}
                      style={{
                        display: "flex",
                        justifyContent: "space-center",
                        alignItems: "center",
                      }}
                    >
                      <RemoveRedEyeIcon style={{ marginRight: "8px" }} /> View More
                    </div>
                  </MenuItem>
                  {isNewStatus && (
                    <MenuItem onClick={handleCloseMenu}>
                      <div
                        onClick={() => handleUpdateDetails()}
                        style={{
                          display: "flex",
                          justifyContent: "space-center",
                          alignItems: "center",
                        }}
                      >
                        <EditNoteIcon style={{ marginRight: "8px" }} /> Update Status
                      </div>
                    </MenuItem>
                  )}
                </Menu>
              </div>
            </div>
          );
        },
      },
    },
  ];

  const options = {
    selectableRows: "none",
    selectToolbarPlacement: "none",
    responsive: "standard",
    elevation: 0,
    serverSide: true,
    count: pagination.total_records,
    page: pagination.current_page - 1,
    rowsPerPage: pagination.per_page,
    rowsPerPageOptions: [5, 10, 25, 50],
    onTableChange: (action, tableState) => {
      switch (action) {
        case 'changePage':
          setCurrentPage(tableState.page + 1);
          break;
        case 'changeRowsPerPage':
          setRowsPerPage(tableState.rowsPerPage);
          setCurrentPage(1);
          break;
        default:
          break;
      }
    },
    textLabels: {
      body: {
        noMatch: loading ? "Loading..." : "No driver requests found",
      },
    },
  };

  const getTheme = () =>
    createTheme({
      palette: {
        mode: "light",
        primary: {
          main: "#2196f3",
        },
        secondary: {
          main: "#03a9f4",
        },
      },
      typography: {
        fontFamily: ["Roboto", "Helvetica", "Arial", "Sans-serif"].join(","),
      },
      components: {
        MuiButton: {
          styleOverrides: {
            root: {
              textTransform: "none",
            },
          },
        },
      },
    });

  // Save remark function
  async function SaveRemark() {
    try {
      if (!statusType || !descriptionRemark.trim()) {
        showAlert("Please select status and provide a remark", "warning");
        return;
      }

      const formData = new FormData();
      formData.append('status', statusType);
      formData.append('note', descriptionRemark);

      const response = await driverRequestsApis.updateStatus(openMenuId, formData, 'admin');

      if (response.success) {
        showAlert("Request status updated successfully", "success");
        handleCloseRemark();
        
        // Refresh data to show updated status
        getData(currentPage, rowsPerPage);
      } else {
        showAlert(response.message || "Failed to update request status", "error");
      }
    } catch (error) {
      console.error("Error updating request status:", error);
      showAlert("Failed to update request status", "error");
    }
  }

  const HeaderDriverRequest = () => {
    return (
      <div className="w-full bg-white shadow-sm mb-6 border-b border-gray-200 font-ubuntu">
        <div className="container mx-auto py-3 px-4">
          <div className="flex items-center gap-x-3">
            {/* Duration dropdown */}
            <div className="relative">
              <div className="flex items-center text-gray-600 text-sm font-normal hover:text-gray-800 focus:outline-none">
                <span>Duration</span>
              </div>
              <div className="absolute hidden bg-white shadow-md rounded-md mt-2 w-48 py-1 z-10">
                {/* Dropdown content would go here */}
              </div>
            </div>

            {/* Date range section */}
            <div className="flex items-center relative">
              <button
                className="text-gray-400 text-sm font-medium flex items-center"
                onClick={(e) => {
                  e.stopPropagation();
                  setDateDropdownOpen(!dateDropdownOpen);
                }}
              >
                Start Date To End Date
                <svg
                  className="w-4 h-4 ml-1"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  />
                </svg>
              </button>

              {dateDropdownOpen && (
                <div
                  className="absolute left-0 top-full mt-1 w-44 bg-white shadow-lg z-10 border border-gray-200"
                  style={{ boxShadow: "0 2px 10px rgba(0,0,0,0.1)" }}
                >
                  <div className="py-1">
                    <button className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                      Today
                    </button>
                    <button className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                      Last 30 Days
                    </button>
                    <button className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                      This Month
                    </button>
                    <button className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                      Last Month
                    </button>
                    <button className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                      Last 90 Days
                    </button>
                    <button className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                      Last 6 Months
                    </button>
                    <button className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                      Last 1 Year
                    </button>
                    <button className="w-full text-left px-4 py-2 text-sm text-gray-700 bg-gray-200">
                      Custom Range
                    </button>
                  </div>
                </div>
              )}
            </div>

            {/* Vertical divider */}
            <div className="h-8 w-px bg-gray-300 my-auto ml-5"></div>

            {/* Status filter */}
            <div className="flex items-center">
              <span className="text-gray-600 text-sm font-medium mr-2">
                Status
              </span>
              <div className="inline-block relative">
                <div className="flex items-center bg-white border border-gray-300 rounded py-1 px-2 text-sm">
                  <select 
                    className="w-full border-none text-gray-900 appearance-none bg-white focus:outline-none"
                    value={statusFilter}
                    onChange={(e) => setStatusFilter(e.target.value)}
                  >
                    <option value="all">All Status</option>
                    <option value="0">Canceled</option>
                    <option value="1">New</option>
                    <option value="2">Accepted</option>
                    <option value="3">In Progress</option>
                    <option value="4">Partial</option>
                    <option value="5">Completed</option>
                  </select>
                  <svg
                    className="w-4 h-4 ml-1"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    />
                  </svg>
                </div>
              </div>
            </div>

            {/* Vertical divider */}
            <div className="h-8 w-px bg-gray-300 my-auto"></div>

            {/* Search input */}
            <div className="relative">
              <div className="flex items-center border border-gray-300 rounded bg-gray-200">
                <div className="pl-2 pr-2">
                  <svg
                    className="w-4 h-4 text-gray-500"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                      clipRule="evenodd"
                    />
                  </svg>
                </div>
                <input
                  type="text"
                  placeholder="Search by client name or ID"
                  className="py-1 px-2 text-sm w-72 border-none rounded-none text-black focus:outline-none"
                  value={searchValue}
                  onChange={(e) => setSearchValue(e.target.value)}
                />
              </div>
            </div>

            {/* Filters button */}
            <div className="ml-auto">
              <button
                className="flex items-center text-gray-600 hover:text-gray-800"
                onClick={handleFiltersOpen}
              >
                <svg
                  className="w-4 h-4 mr-1"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fillRule="evenodd"
                    d="M3 3a1 1 0 011-1h12a1 1 0 011 1v3a1 1 0 01-.293.707L12 11.414V15a1 1 0 01-.293.707l-2 2A1 1 0 018 17v-5.586L3.293 6.707A1 1 0 013 6V3z"
                    clipRule="evenodd"
                  />
                </svg>
                <span className="text-sm font-medium">Filters</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <StatusAlert
        open={alertOpen}
        setOpen={setAlertOpen}
        message={alertMessage}
        severity={alertSeverity}
      />
      
      <HeaderDriverRequest />
      
      <Dialog
        fullWidth
        maxWidth="md"
        open={openRemark}
        onClose={handleCloseRemark}
        TransitionComponent={Transition}
        PaperProps={{
          style: {
            position: "absolute",
            background: "#141b2d",
            top: "0",
            backgroundColor: "white",
            maxHeight: "95%",
            margin: "auto",
            overflowX: "hidden",
            zIndex: 1200,
          },
        }}
      >
        <AppBar sx={{ position: "relative" }}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleCloseRemark}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} component="div">
              Update Request Status
            </Typography>
          </Toolbar>
        </AppBar>

        <Box sx={{ background: "#fff" }}>
          <Grid
            container
            spacing={4}
            style={{ color: "black", padding: "20px" }}
          >
            <Grid item xs={11} sm={4} md={3}>
              <Stack direction="column">
                <Typography variant="p" gutterBottom style={{ color: "black" }}>
                  Status
                </Typography>
                <Select
                  value={statusType}
                  autoFocus
                  onChange={(e) => setStatusType(e.target.value)}
                  displayEmpty
                  inputProps={{ "aria-label": "Without label" }}
                  sx={{
                    border: "1px solid black",
                    boxSizing: "border-box",
                    "& .MuiOutlinedInput-root": {
                      borderColor: "black !important",
                      "&:hover fieldset": {
                        borderColor: "black !important",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "black !important",
                      },
                    },
                    color: "black",
                  }}
                >
                  <MenuItem value="">
                    <span style={{ color: "gray" }}>Select Status</span>
                  </MenuItem>
                  <MenuItem value={1}>Created</MenuItem>
                  <MenuItem value={2}>Started</MenuItem>
                  <MenuItem value={3}>Completed</MenuItem>
                </Select>
              </Stack>
            </Grid>
            <Grid item xs={11} sm={7.5} md={8.5}>
              <Stack direction="column" sx={{ width: "100%" }}>
                <Typography variant="p" gutterBottom style={{ color: "black" }}>
                  Remark<span style={{ color: "red" }}>*</span>
                </Typography>

                <ReactQuill
                  value={descriptionRemark}
                  onChange={setDescriptionRemark}
                  modules={modules}
                  theme="snow"
                  style={{
                    width: "100%",
                    height: "70px",
                    boxSizing: "border-box",
                    color: "black",
                    borderBlockColor: "black",
                  }}
                />
              </Stack>
            </Grid>
          </Grid>

          <Grid container sx={{ padding: "50px 0 30px 20px" }}>
            <Grid item xs={11} className="messageFooter">
              <Box 
                className="response" 
                onClick={SaveRemark}
                sx={{
                  display: 'inline-block',
                  backgroundColor: '#2196f3',
                  color: 'white',
                  padding: '8px 16px',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  marginRight: '10px',
                  '&:hover': {
                    backgroundColor: '#1976d2'
                  }
                }}
              >
                Save
              </Box>
              <Box 
                className="cancel" 
                onClick={handleCloseRemark}
                sx={{
                  display: 'inline-block',
                  backgroundColor: '#f5f5f5',
                  color: '#333',
                  padding: '8px 16px',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  border: '1px solid #ddd',
                  '&:hover': {
                    backgroundColor: '#e0e0e0'
                  }
                }}
              >
                Cancel
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Dialog>

      <Divider />
      <ListItemText style={{ background: "white", margin: 0 }}>
        <ThemeProvider theme={getTheme()}>
          <Box
            sx={{
              maxWidth: "100%",
            }}
          >
            <MUIDataTable
              title={
                <span
                  style={{
                    fontWeight: 700,
                    fontSize: "1.5rem",
                    color: "#333",
                  }}
                >
                  Driver Requests
                </span>
              }
              data={requestData}
              columns={columns}
              options={options}
            />
          </Box>
        </ThemeProvider>
      </ListItemText>
    </>
  );
}

export default DriverRequest;